export default {
    ready: (state, getters, rootState, rootGetters) => {
        return rootGetters['v4/mode/get']('multipleUploadsOfData') || !state.uploaded
    },

    getGlobalSequence: (state) => {
        return state.globalSequence
    },

    getTotalCompletedTracks: (state) => {
        return state.track
    },

    getTotalUploads: (state) => {
        return state.upload
    },

    serverIsAvailable: (state) => {
        return state.serverIsAvailable
    },

    lastUpload: (state) => {
        return state.lastUploadDate
    }
}
